import uuid from 'uuid/v1';
export const ROLE_LIST_ACTION_TYPES = {
  ROLE_LIST_CHANGE_PROCESSING: 'ROLE_LIST_CHANGE_PROCESSING',
  ROLE_LIST_CHANGE_STATUS: 'ROLE_LIST_CHANGE_STATUS',
  ROLE_LIST_SET_DATA_BY_KEY: 'ROLE_LIST_SET_DATA_BY_KEY',
};

let globalRequestId;
export function getRoleListData(
  pageObject,
  stateKeyForDataSaving,
  methodUrl,
  processingKey,
  organizationListsUrl,
) {
  return async (dispatch, getState, { getAxios, getListAxios }) => {
    const axios = organizationListsUrl ? getListAxios() : getAxios();
    const localRequestId = uuid();
    globalRequestId = localRequestId;

    dispatch(changeRoleListProcessingState(true, processingKey));

    const response = await axios.get(methodUrl);

    dispatch(changeRoleListProcessingState(false, processingKey));

    if (!response || response.code !== 'success' || !pageObject.mounted) {
      return response;
    }

    const { data } = response;

    dispatch(setRoleListDataByKey(data, stateKeyForDataSaving));

    return response;
  };
}

export function setRoleListDataByKey(data, stateKeyForDataSaving) {
  return {
    type: ROLE_LIST_ACTION_TYPES.ROLE_LIST_SET_DATA_BY_KEY,
    payload: {
      data,
      stateKeyForDataSaving,
    },
  };
}

export function changeRoleListProcessingState(newState, processingDestination) {
  return {
    type: ROLE_LIST_ACTION_TYPES.ROLE_LIST_CHANGE_PROCESSING,
    payload: { newState, processingDestination },
  };
}

export function changeListStatus(name) {
  return {
    type: ROLE_LIST_ACTION_TYPES.ROLE_LIST_CHANGE_STATUS,
    payload: name,
  };
}

export function doAccessAction({
  requestMethod,
  url,
  body = {},
  userId,
  requestId,
  processingKey,
  stateKeyForDataSaving,
  rewriteAccessRequestKey,
}) {
  return async (dispatch, getState, { getAxios, getListAxios }) => {
    const axios = getAxios();

    dispatch(changeRoleListProcessingState(true, processingKey));

    const response = await axios[requestMethod](url, body);

    dispatch(changeRoleListProcessingState(false, processingKey));

    if (!response || response.code !== 'success') {
      return response;
    }

    if (!stateKeyForDataSaving) return response;

    const { data } = response;

    const { roleList } = getState();
    const { items: listItems } = roleList[stateKeyForDataSaving];
    const newListItems = (listItems || []).map((listItem) => {
      if (rewriteAccessRequestKey === 'id' && listItem.id === userId) {
        return {
          ...listItem,
          accessRequest: { ...data },
        };
      }
      if (
        rewriteAccessRequestKey === 'requestId' &&
        listItem.accessRequest &&
        listItem.accessRequest.id === requestId
      ) {
        return {
          ...listItem,
          accessRequest: { ...data },
        };
      }
      return listItem;
    });

    dispatch(
      setRoleListDataByKey(
        {
          ...roleList[stateKeyForDataSaving],
          items: newListItems,
        },
        stateKeyForDataSaving,
      ),
    );

    return response;
  };
}
